export const InvestItemInit = () => {
    //

    const handleNameHeight = () => {
        let height = 0;
        const name = $(".invest_name");
        name.map((a, b) => {
            const name_height = $(b).innerHeight();
            if (name_height > height) {
                height = name_height;
            }
        });
        name.css({
            height,
        });
    };

    //
    const handleTxtHeight = () => {
        let height = 0;
        const txt = $(".invest_txt");
        txt.map((a, b) => {
            const txt_height = $(b).innerHeight();
            if (txt_height > height) {
                height = txt_height;
            }
        });
        txt.css({
            height,
        });
    };
    //
    const handleReset = () => {
        const name = $(".invest_name");
        const txt = $(".invest_txt");
        txt.css({
            height: 'auto',
        });
        name.css({
            height: 'auto',
        });
    };

    $(window).on("load resize", function () {
        handleReset();
        handleNameHeight();
        handleTxtHeight();
    });

};